// import React, { useState } from "react";
// import { Button, CircularProgress, Backdrop } from "@mui/material";
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
// import { logger } from "../../../utils/logger";
// import {getSystemFormattedTimestamp} from "../../../utils/dateFormatted";

// const DownloadButton = ({ data, type, labelposition, username, role }) => {
//   const [loading, setLoading] = useState(false);
//   const BaseUrl = process.env.REACT_APP_BASE_URL;

//   const handleDownload = async (groupType) => {
//     setLoading(true);
//     try {
//       const endpoint =
//         groupType === "small" ? "download-npfuaf-small-group" : "download-npfuaf-large-group";
//       const response = await fetch(`${BaseUrl}api/npfuaflabel/download-npfuaf`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ data, labelposition }),
//       });

//       if (!response.ok) {
//         let errorMsg = "Failed to generate PDF";
//         try {
//           const errorData = await response.json();
//           errorMsg = errorData.message || errorMsg;
//         } catch {}
//         throw new Error(errorMsg);
//       }

//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.download = `npfuafLabel-${getSystemFormattedTimestamp()}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//       logger.info("PDF downloaded successfully", {
//         groupType,
//         filterType: type,
//         username,
//         role,
//         totalRecords: data?.length || 0,
//       });
//     } catch (err) {
//       logger.error("Error downloading PDF", {
//         groupType,
//         filterType: type,
//         username,
//         role,
//         error: err.message,
//       });
//       alert(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       {/* <Button
//         variant="contained"
//         color="primary"
//         onClick={() => handleDownload("small")}
//         style={{ marginRight: 10 }}
//       >
//         <PictureAsPdfIcon style={{ marginRight: 8 }} />
//         Download Small Group
//       </Button> */}
//       <Button
//        variant="contained"
//        color="primary"
//         onClick={() => handleDownload()}
//         style={{ marginRight: 10 }}
//       >
//         <PictureAsPdfIcon style={{ marginRight: 8 }} />
//         Download PDF
//       </Button>
//       {/* <Button
//         variant="contained"
//         color="secondary"
//         onClick={() => handleDownload("large")}
//       >
//         <PictureAsPdfIcon style={{ marginRight: 8 }} />
//         Download Large Group
//       </Button> */}
//       <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
//         <CircularProgress color="inherit" />
//         <span style={{ marginLeft: 10 }}>Generating PDF, please wait...</span>
//       </Backdrop>
//     </>
//   );
// };

// export default DownloadButton;
import React, { useState } from "react";
import { Button, CircularProgress, Backdrop } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { logger } from "../../../utils/logger";
import { getSystemFormattedTimestamp } from "../../../utils/dateFormatted";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ExportFormatModal from "../../ExportFormatModal";

const DownloadButton = ({ data, type, labelposition, username, role }) => {
  const [loading, setLoading] = useState(false);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const BaseUrl = process.env.REACT_APP_BASE_URL;

  const handleDownload = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${BaseUrl}api/npfuaflabel/download-npfuaf`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data, labelposition }),
      });
      if (!response.ok) {
        let errorMsg = "Failed to generate PDF";
        try {
          const errorData = await response.json();
          errorMsg = errorData.message || errorMsg;
        } catch {}
        throw new Error(errorMsg);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `npfuafLabel-${getSystemFormattedTimestamp()}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      logger.info("PDF downloaded successfully", {
        filterType: type,
        username,
        role,
        totalRecords: data?.length || 0,
      });
    } catch (err) {
      logger.error("Error downloading PDF", {
        filterType: type,
        username,
        role,
        error: err.message,
      });
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleExcelDownload = () => {
    const rows = Array.isArray(data) ? data : [];
    if (!rows.length) return alert("No data to export");
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "NpfUafLabels");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([buf], { type: "application/octet-stream" }),
      `npfuafLabel_${getSystemFormattedTimestamp()}.xlsx`
    );
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={() => setExportModalOpen(true)}
        style={{ marginRight: 10 }}
      >
        <PictureAsPdfIcon style={{ marginRight: 8 }} />
        Download
      </Button>
      <ExportFormatModal
        open={exportModalOpen}
        onClose={() => setExportModalOpen(false)}
        onSelectPDF={handleDownload}
        onSelectExcel={handleExcelDownload}
      />
      <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
        <span style={{ marginLeft: 10 }}>Generating PDF, please wait...</span>
      </Backdrop>
    </>
  );
};

export default DownloadButton;